// For infinite scrolling
$(window).bind('scroll', function() {
    var scrollHeight = $(document).height();
	var scrollPosition = $(window).height() + $(window).scrollTop();
  	var scrolly = (scrollHeight - scrollPosition) / scrollHeight;
	if ((scrollHeight - scrollPosition) / scrollHeight <= 0.79) {
	    $('#collection .product-item .product-image a').each(function(){
      // Get all the attributs
            var hello = this.href;
            //Replace the attributes from where you want to start with.
          var remo = hello.substring(hello.indexOf("/products") + 0);
          // commit the rerplace.
            $(this).attr("href", remo);
        });
	}
});